module.exports = __webpack_public_path__ + "static/media/placeHolderUser.9b89ba3c.png";